<template>
    <div class="pa-5" v-if="activeWorkOrder">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Sales order number") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.sales_order_number ? activeWorkOrder.sales_order_number : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Estimated production time") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.estimated_time ? activeWorkOrder.estimated_time : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Production order number") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.production_order_number ? activeWorkOrder.production_order_number : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Production date") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.production_date ? activeWorkOrder.production_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Production time") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.production_time ? activeWorkOrder.production_time : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Planned quantity") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.planned_quantity ? activeWorkOrder.planned_quantity : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Product code") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.product_code ? activeWorkOrder.product_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Product name") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.product_name ? activeWorkOrder.product_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Product EAN") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrder.product_ean ? activeWorkOrder.product_ean : "-" }}
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Store from "@/store";
export default {
    name: "general-info-tab",

    data() {
        return {};
    },
    async mounted() {},
    computed: {
        ...mapState("WorkOrderStore", ["activeWorkOrder"])
    },
    methods: {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
